/**
 * 디스플레이가 선택된 연유, 전략(Strategy)을 나타냅니다.
 */
export enum DisplaySelectedStrategy {
  /**
   * 쿼리스트링에 디스플레이 요청이 있으면 최우선으로 간주합니다
   */
  Querystring,
  /**
   * UA 보다 UaHint 가 더욱 정확하기 때문에 우선적으로 간주합니다
   */
  UaHint,
  /**
   * 다른 여지가 없으면 UA 로 간주합니다
   */
  Ua,
  /**
   * 예상하지 못한 방식으로 접근할 경우 None 입니다.
   */
  None,
}
